import { defineAsyncComponent } from 'vue';

const FunnelTemplate = () => import('./funnel/FunnelTemplate.vue');

// Mesmas chaves de Kanban::WhiteLabelLanding::PAGES; cada página num chunk próprio.
export const TEMPLATES = {
  home: defineAsyncComponent(() => import('./home/HomeTemplate.vue')),
  whatsapp: defineAsyncComponent(
    () => import('./whatsapp/WhatsappTemplate.vue')
  ),
  cabeleireiros: defineAsyncComponent(FunnelTemplate),
  contabilidade: defineAsyncComponent(FunnelTemplate),
  bloqueio: defineAsyncComponent(FunnelTemplate),
  trafego: defineAsyncComponent(FunnelTemplate),
  extrator: defineAsyncComponent(
    () => import('./extrator/ExtratorTemplate.vue')
  ),
  manychat: defineAsyncComponent(
    () => import('./manychat/ManychatTemplate.vue')
  ),
  marina: defineAsyncComponent(() => import('./marina/MarinaTemplate.vue')),
};
